import { designationService } from "../../../../Api/Services/DesignationService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IEditDesignationResponse } from "../../types";

export const fetchEditDesignation = createServiceAsyncThunk<
  IEditDesignationResponse,
  number
>(
  ACTION_NAMES.EDIT_DESIGNATION,
  (id) => designationService.getEditDesignation(id),
  ERROR_MESSAGES.EDIT_DESIGNATION_FAILURE
);

const editDesignationSlice = createGenericSlice<
  IEditDesignationResponse,
  number
>(SLICE_NAMES.EDIT_DESIGNATION_SLICE, fetchEditDesignation);

export const {
  clearError: clearEditDesignationError,
  clearSuccessMessage: clearEditDesignationSuccessMessage,
} = editDesignationSlice.actions;

export default editDesignationSlice.reducer;
